import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 350px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  height: calc(100vh - 225px);
  overflow-y: auto;
  overflow-x: hidden;
  gap: 4px;
`;

export const Pagination = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 10px 8px 12px;
  border-top: 1px solid #e5e9f0;
  background: #fff;

  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    overflow: hidden;
  }

  li { flex: 0 0 auto; }
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-width: 28px;
    height: 28px;
    padding: 0 5px;
    border-radius: 8px;
    color: #1d9bf0;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
  }
  a:hover { background: #edf7fe; }
  .active a { color: #fff; background: #1d9bf0; box-shadow: 0 2px 6px rgb(29 155 240 / 24%); }
  .previous a, .next a { color: #586174; background: #f1f4f8; }
  .disabled a { color: #c4cad3; cursor: default; pointer-events: none; }
  .break a { min-width: 20px; padding: 0; color: #8a93a3; }
`;
